<mat-form-field>
  <!--  <mat-label>Enter a date range</mat-label>-->
  <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker" [disabled]="disabled">
    <input
      matStartDate
      formControlName="start"
      placeholder="{{ 'TABLE.DATE_FROM' | translate }}"
      (focus)="formFocused = true"
      (blur)="formFocused = false"
    />
    <input
      matEndDate
      formControlName="end"
      placeholder="{{ 'TABLE.DATE_TO' | translate }}"
      (focus)="formFocused = true"
      (blur)="formFocused = false"
    />
  </mat-date-range-input>
  <!--  <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>-->
  <mat-datepicker-toggle [disabled]="disabled" matIconSuffix [for]="picker"></mat-datepicker-toggle>

  <mat-date-range-picker #picker></mat-date-range-picker>

  @if (rangeForm.controls.start.hasError('matStartDateInvalid')) {
    <mat-error>Invalid start date</mat-error>
  }
  @if (rangeForm.controls.end.hasError('matEndDateInvalid')) {
    <mat-error>Invalid end date</mat-error>
  }
</mat-form-field>
<!--<p>Selected range: {{rangeForm.value | json}}</p>-->
<!--<span>{{ getRangeString(currentRange) }}</span>-->
